import { QuestionBase } from './question-base.model';

export class monthYearQuestion extends QuestionBase<number> {
    controlType = 'monthYearPicker';
    disabled: boolean;
    visible: boolean;
    placeholder: string = '';
    min: any;
    type: any;
    format:any = "";
    disablePreviousYearMonth: boolean = false
    disableNextYearMonth: boolean = false
    constructor(options: {} = {}) {
        super(options);
        this.disabled = options['disabled'] || false;
        this.value = options['value'] || 0;
        this.visible = options['visible'] != undefined ? options['visible'] : true,
        this.min = options['min'] || 0;
        this.type = options['type'] || 'integer';
        this.placeholder = options['placeholder'] || '';
        this.format = options['format'] || "";
        this.disablePreviousYearMonth = options['disablePreviousYearMonth'] != undefined ? options['disablePreviousYearMonth'] : false;
        this.disableNextYearMonth = options['disableNextYearMonth'] != undefined ? options['disableNextYearMonth'] : false;
    }
}